module.exports = __webpack_public_path__ + "img/intro_uk.2d09349c.svg";